// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16bn_","label":"styles_label__3jFt9"};